import { FormChangePassword } from 'components/user/user-detail/tab-profile/FormChangePassword'
import { useState } from 'react'
import { generatePasswordAlphanumeric } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_USER } from 'services/apiUser'
import { useSelector } from 'react-redux'
import { Alert } from 'avo-ui'

export const FormChangePasswordContainer = ({ show, onHide }) => {
    const [newPassword, setNewPassword] = useState('')
    const [errorForm, setErrorForm] = useState('')
    const { userDetails } = useSelector((state) => state.userReducer)
    const { fetching: changePasswordApi, isLoading } = useFetch(API_USER.CHANGE_PASSWORD)

    const onHideForm = () => {
        setErrorForm('')
        onHide()
    }

    const onGenerate = () => {
        setNewPassword(generatePasswordAlphanumeric())
    }

    const onChangeForm = (value) => {
        setNewPassword(value)
    }

    const onSubmit = () => {
        if (newPassword) {
            changePasswordApi({ new_password: newPassword }, userDetails?.profile.id)
                .then(() => {
                    onHideForm()
                    return Alert({
                        icon: 'success',
                        title: 'Success',
                        message: 'Password Changed !',
                    })
                })
                .catch((error) => setErrorForm(error?.data[0]?.message))
        } else {
            setErrorForm('New password is required')
        }
    }

    const props = {
        show,
        newPassword,
        errorForm,
        onHideForm,
        onGenerate,
        onChangeForm,
        isLoading,
        onSubmit,
    }

    return <FormChangePassword {...props} />
}
